import { ICiPdSDiagnosticFilter } from "../../model";

export class SetDiagnosticFiltersValuesCommand {
  constructor(public payload: ICiPdSDiagnosticFilter) {}
}
